import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { DeliveryFeatureDefinition } from '@digiwall/goliath-documents/config';
import { ParametersComponent } from '../delivery-management/parameters.component';

const routes: Routes = [
  {
    path: 'delivery',
    canMatch: [DeliveryFeatureDefinition],
    children: [
      {
        path: 'delivery-config',
        component: ParametersComponent,
        data: {
          category: 'delivery',
          breadcrumb: {
            label: '::Menu:Settings:Delivery',
            skip: true,
          } as BreadcrumbDefinition,
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'delivery-definition',
          },
          {
            path: 'delivery-definition',
            title: 'ERP::Menu:Deliveries:DeliveryRoutesDefinition',
            loadChildren: () =>
              import('../delivery/delivery-definition/delivery-definition.module').then(
                m => m.DeliveryDefinitionModule,
              ),
          },
        ],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsDeliveryRoutingModule {}
